import { AnyAction, Dispatch } from 'redux'

import { PayrollPeriod } from '../../../../@paco/entities/PayrollPeriod/PayrollPeriod'

import { getIncludes } from '../../../../helpers/api/tracksApi'
import { getOpenTracksInDateRange } from '../../../../helpers/api-ts/track'
import { TrackType } from '../../../../models'
import { setError, setIsLoading, setOpenTracks } from './openTracksReducer'

export const fetchOpenTracks = (payrollPeriod: PayrollPeriod) => async (dispatch: Dispatch<AnyAction>): Promise<void> => {
    dispatch(setIsLoading(true))
    dispatch(setError(''))

    const { start, end } = payrollPeriod.period

    try {
        const response = await getOpenTracksInDateRange(
            start,
            end,
            getIncludes(TrackType.open),
        )

        dispatch(setOpenTracks(response.data))
    } catch (error) {
        console.error('[fetchOpenTracks]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
